<template>
    <div id="order_info">
        <div class="row">
            <div class="col-lg-8 col-sm-12">
                <div class="card">
<!--                    <div class="card-header">-->
<!--&lt;!&ndash;                        <div class="row">&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="col-xs-12">&ndash;&gt;-->
<!--&lt;!&ndash;                                <p>Заказ на сумму {{order_sum}}</p>&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                                <p>{{order_uuid}}</p>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                    </div>-->
                    <div class="card-content">
                        <div class="row" style="padding: 15px;">
                            <textarea class="form-control" placeholder="Коментарий к заказу" rows="3" >{{message}}</textarea>
                        </div>
                        <div class="row">
                            <div class="col-xs-5">
                                <button class="btn btn-wd">Отмена</button>
                            </div>
                            <div class="col-xs-7">
                                <button class="btn btn-success btn-fill btn-wd" @click="send(order_uuid)">Отправить</button>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>


<script>
  export default {
    name: 'OrderInfo',
    props: ['order_sum', 'order_uuid'],
    data () {
      return {
        order: [],
        resp: {},
        message: ''
        // order_uuid: '',
        // order_sum: 0
      }
    },
    methods: {
      send (orderid) {
        this.message = 'Нажал'
        this.load_order(orderid)
        // console.log(this.order)
        // this.get_json()
        //   .then(this.get_json())
      },
      get_json () {
        // eslint-disable-next-line no-return-assign
        this.$db.settings.toArray().then((x) => this.resp = x)
          .then(this.resp.push({ddate: this.order.dt}))
          .then(console.log(this.resp))
      },
      load_order (orderid) {
        this.message = 'пришел в load_order'
        const axios = require('axios')
        this.$db.orders.where({'id': orderid}).toArray().then((order) => {
          // this.order = order
          return order
        })
          .then((order) => {
            var date = '2019-09-27 13:13:09.267'
              // new Date(order[0].dt).toISOString()
            this.resp.goods = order[0].goods
            // this.resp.dt = order[0].dt
            this.resp.number = order[0].dt
              // order[0].dt
            this.resp.ddate = date
            this.resp.ddate2 = date
            this.resp.deliverydate = date
            this.resp.info = 'comment'
            // console.log(this.resp)
            this.$db.settings.toArray()
              .then((settings) => {
                for (let key in settings[0]) {
                  this.resp[key] = settings[0][key]
                  // console.log(key + ':' + settings[0][key])
                }
                this.message = 'ща пошлю'
                axios({
                  method: 'post',
                  url: 'https://lic2.akitorg.ru/ms_au/j.php',
                  headers: {'X-Akitorg-Agent': '18', 'X-Authorization': 'R30TSsZ53SWPVe3K', 'X-Akitorg-User-Id': '227'},
                  data: this.resp
                })
                  .then(console.log('************************'))
                  // .catch(function (error) {
                  //   // handle error
                  //   console.log(error)
                  //   this.message = error
                  // })
                  .catch((error) => {
                    // handle error
                    console.log(error)
                    this.message = error
                  })
                  .finally(() => {
                    // always executed
                    console.log('фсё')
                    this.message = 'фсё'
                  })
                // console.log(this.resp)
              })
          })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/OrderInfo.vue